export function buildUrl(type:string, param: string = '') {
  switch (type) {
    case 'campos_dinamicos':
      return `api/campos_dinamicos/buscar/${param}`;

    case 'campos_personalizados':
      return `api/campos_personalizados/buscar/${param}`;

    case 'tipos_identificadores':
      return 'api/generico/tipos_identificadores';

    case 'buscar_mutuas':
      return 'api/mutuas/buscar';

    case 'buscar_provincias':
      return `api/generico/provincias/${param}`;

    case 'buscar_paises':
      return 'api/generico/paises';

    case 'set_notas':
      return `api/notas/agregar?clave_entidad=PACIENTE&entidad_id=${param}`;

    case 'get_notas':
      return `api/notas/obtener?clave_entidad=PACIENTE&entidad_id=${param}`;

    case 'guardar_paciente':
      return 'api/pacientes/guardar';

    case 'guardar_rgpd':
      return `api/rgpd/paciente/${param}/guardar`;

    case 'get_rgpd':
      return `api/rgpd/paciente/${param}/condiciones`;

    case 'get_pdf_rgpd':
      return 'api/informe/312/plantilla/72/imprimir';

    case 'get_url_pdf_aws_rgpd':
      return 'api/informe/rgpd/aws';

      case 'get_url_pdf_rgpd':
      return 'api/informe/rgpd/paciente';

    case 'get_pacientes_grupos':
      return 'api/generico/gruposcliente';

    case 'get_pacientes_tiendas':
      return 'api/tiendas/buscar';

    case 'get_pacientes_profesiones':
      return 'api/generico/profesiones';

    case 'get_pacientes':
      return 'api/pacientes/buscar';

    case 'get_usuarios':
      return 'api/usuarios/buscar';

    case 'get_prescriptores':
      return 'api/doctores/buscar';

    case 'get_graduaciones':
      return 'api/graduacionoptometrica/buscar?tipo_respuesta=listado';

    case 'get_graduacion':
      return 'api/graduacionoptometrica/buscar?tipo_respuesta=mostrar';

    case 'get_graduacion_extendida':
      return 'api/graduacionoptometrica/buscar?tipo_respuesta=mostrar_extendido';

    case 'set_graduacion':
      return 'api/graduacionoptometrica/guardar?tipo_respuesta=json';

    case 'comprobar_paciente_duplicado':
      return 'api/pacientes/comprobarDuplicidad';
    
    case 'get_foto_paciente':
      return `api/pacientes/obtenerFotoPaciente?paciente_id=${param}`

    case 'get_paciente_v2':
      return 'api/v1/core/Paciente/read'

    case 'get_paciente_search':
      return 'api/v1/core/Paciente/search'
  }
}
